/* Building Blox — cart upsell / cross-sell behaviour.
   The markup lives inside [data-minimog-cart-items], which Minimog replaces with
   fresh server HTML on every cart change, so everything here is delegated from
   document and holds no references to elements inside that region.

   After a change we ask Minimog to refresh itself through its own pub/sub
   (MinimogEvents + MinimogTheme.pubSubEvents.cartUpdate). Fallbacks are provided
   for the case where another app has replaced the cart drawer. */
(function () {
  'use strict';
  if (window.__bbCartUpsell) return;
  window.__bbCartUpsell = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function url(path) { return (ROOT.replace(/\/$/, '')) + path; }

  function postJSON(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && (data.description || data.message)) || ('HTTP ' + r.status));
        return data;
      });
    });
  }

  /* Ask the theme to re-render the cart. Returns nothing; failures are non-fatal. */
  function refreshCart() {
    fetch(url('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        var emitted = false;
        try {
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
              cart: state, source: 'bb-cart-upsell'
            });
            emitted = true;
          }
        } catch (e) { /* fall through */ }
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { cart: state }, bubbles: true }));
        } catch (e) { /* ignore */ }
        if (!emitted) manualRerender();
      })
      .catch(function () { manualRerender(); });
  }

  /* Last resort: pull the cart section and swap the regions ourselves. */
  function manualRerender() {
    fetch(url('/cart?section_id=cart-template'))
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        var fresh = doc.querySelector('[data-minimog-cart-items]');
        document.querySelectorAll('[data-minimog-cart-items]').forEach(function (node) {
          if (fresh) node.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () { /* give up quietly */ });
  }

  function flash(btn, ok) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    if (ok) {
      btn.classList.add('is-done');
      setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
    }
  }

  /* ---------- add buttons (cross-sell cards and quantity nudges) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-add], [data-bb-add-selected]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    var id = btn.getAttribute('data-bb-add');
    if (btn.hasAttribute('data-bb-add-selected')) {
      var card = btn.closest('.bb-up__card');
      var sel = card && card.querySelector('[data-bb-variant]');
      id = sel ? sel.value : null;
    }
    var qty = parseInt(btn.getAttribute('data-bb-qty') || '1', 10) || 1;
    if (!id) return;
    busy = true;
    btn.classList.add('is-loading');
    postJSON('/cart/add.js', { items: [{ id: Number(id), quantity: qty }] })
      .then(function () { flash(btn, true); refreshCart(); })
      .catch(function (err) {
        flash(btn, false);
        try {
          if (window.MinimogTheme && window.MinimogTheme.Notification) {
            window.MinimogTheme.Notification.show({ method: 'open', message: err.message, type: 'warning' });
          }
        } catch (e2) { /* ignore */ }
      })
      .then(function () { setTimeout(function () { busy = false; }, 350); });
  });

  /* ---------- add-on checkboxes ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-bb-addon]');
    if (!input) return;
    if (busy) { input.checked = !input.checked; return; }
    var id = Number(input.getAttribute('data-bb-addon'));
    if (!id) return;
    var row = input.closest('.bb-up__addon');
    busy = true;
    if (row) row.classList.add('is-busy');
    var work = input.checked
      ? postJSON('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      : postJSON('/cart/change.js', { id: id, quantity: 0 });
    work
      .then(function () { refreshCart(); })
      .catch(function () { input.checked = !input.checked; if (row) row.classList.remove('is-busy'); })
      .then(function () { setTimeout(function () { busy = false; }, 350); });
  });
})();
